jQuery(document).ready(function () {
// Get base price from the DOM (only once)
let basePrice = parseFloat($('.price-item--regular').first().text().replace(/[^\d\.]/g, ''));

// Parse quantity safely (returns null when input is empty or invalid while typing)
function parseQtySafe($input) {
    const raw = $input.val();
    if (raw === '' || raw === null) return null;            // user is still typing -> don't force 1
    const n = parseInt(raw, 10);
    return Number.isNaN(n) ? null : n;
}

function renderPriceForQty(qty) {
    // ensure final qty is at least 1
    qty = Math.max(1, qty || 1);
    const total = Math.round(basePrice * qty);
    $('.price-item--regular').text(total + " €");
}

// When clicking + / - (Shopify usually updates the input first, so read value after event loop)
$(document).on('click', '.quantity__button', function () {
    const $input = $(this).closest('.quantity').find('.quantity__input');

    // Let Shopify's native handler (if any) update the input value first
    setTimeout(() => {
        const qty = parseQtySafe($input) ?? 1;   // if null (shouldn't be for click), use 1
        renderPriceForQty(qty);
    }, 0);
});

// While typing: update live only when there's a valid number (don't force 1 for empty)
$(document).on('keyup', '.quantity__input', function () {
    const $input = $(this);
    const qty = parseQtySafe($input);

    if (qty === null) {
        // user cleared input or typing partial -> don't change the visible price
        return;
    }
    // If they typed a number, ensure >= 1 and update
    if (qty < 1) {
        $input.val(1);
        renderPriceForQty(1);
    } else {
        renderPriceForQty(qty);
    }
});

// On change / blur (finalize): ensure value is at least 1 and update price
$(document).on('change blur', '.quantity__input', function () {
    const $input = $(this);
    let qty = parseQtySafe($input);

    if (qty === null || qty < 1) {
        $input.val(1);
        qty = 1;
    }

    renderPriceForQty(qty);
});



  
  $(document).on('change', '.quantity__input', function () {
    let newQty = $(this).val(); // get updated quantity

    // update the checkout URL
    let updatedUrl = `https://shop.gethashwallet.com/cart/55769078104412:${newQty}?return_to=checkout`;

    $('.checkout-btn').attr('href', updatedUrl);
});

  // Accordion click event
  $('.fp-accordion-header').on('click', function () {
    let $header = $(this);
    let $content = $header.next('.fp-accordion-content');
    let isOpen = $header.attr('aria-expanded') === 'true';

    // Close all other accordions
    $('.fp-accordion-header').not($header).attr('aria-expanded', 'false');
    $('.fp-accordion-content').not($content).slideUp(300).attr('hidden', true);
    $('.product-header3_accordion-icon').not($header.find('.product-header3_accordion-icon'))
      .removeClass('rotate');

    // Toggle this accordion
    if (!isOpen) {
      $header.attr('aria-expanded', 'true');
      $content.slideDown(300).attr('hidden', false);
      $header.find('.product-header3_accordion-icon').addClass('rotate');
    } else {
      $header.attr('aria-expanded', 'false');
      $content.slideUp(300).attr('hidden', true);
      $header.find('.product-header3_accordion-icon').removeClass('rotate');
    }
  });

  // Wrap all lines inside a container (if not already wrapped)
  $('.fp-feature-group').each(function () {
    if ($(this).find('.fp-fg-body').length === 0) {
      $(this).find('.fp-line').wrapAll('<div class="fp-fg-body" hidden></div>');
    }
  });

  // Accordion behavior
  $('.fp-fg-title').on('click', function () {
    let $group = $(this).closest('.fp-feature-group');
    let $body = $group.find('.fp-fg-body');
    let isOpen = $group.hasClass('open');

    // Close all others
    $('.fp-feature-group').not($group).removeClass('open');
    $('.fp-fg-body').not($body).slideUp(300).attr('hidden', true);

    // Toggle current one
    if (!isOpen) {
      $group.addClass('open');
      $body.slideDown(300).attr('hidden', false);
    } else {
      $group.removeClass('open');
      $body.slideUp(300).attr('hidden', true);
    }
  });

});